import { render, staticRenderFns } from "./TableEdit.vue?vue&type=template&id=52df9cf2&"
import script from "./TableEdit.vue?vue&type=script&lang=js&"
export * from "./TableEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports